import { patchReturnGoA11y } from "../utilities/Helpers/UI/ReturnGoA11y";

// Loaded only by sections/page__main.liquid, and only when the page body
// embeds the ReturnGO portal (`#ReturngoPortalEmbedding`), so the patch stays
// out of main.js and off every other page. ReturnGO renders client-side, so
// the patch's own observers handle the portal appearing later.
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => patchReturnGoA11y());
} else {
    patchReturnGoA11y();
}
